import { Flex, Text } from "@radix-ui/themes";

interface LoadingIndicatorProps {
    text?: string;
}

function LoadingIndicator({ text = "Loading..." }: LoadingIndicatorProps) {
    return (
        <Flex align="center" gap="2" p="2">
            <div className="loading" />
            <Text size="2" color="gray">
                {text}
            </Text>
        </Flex>
    );
}

export default LoadingIndicator;
